/*
 * Cordial-IA-2026-06-29 - Mecanique cadeau au seuil (fait-maison, client-side)
 * Plan Basic : pas de Shopify Functions. Ce script gere l'auto-ajout / retrait
 * des cadeaux selon le sous-total du panier (hors lignes cadeaux), pour TOUT
 * panier quel que soit le chemin.
 *
 * LIMITES ASSUMEES (client-side) : si JS desactive, ou si le client va au
 * checkout sans repasser par le panier, ou modifie le panier dans le checkout,
 * la mecanique ne s'applique pas (le checkout ne reexecute pas ce script). Un
 * cadeau peut donc theoriquement "fuir" (commande sous le seuil avec cadeau) ou
 * manquer. Compromis assume sans Functions. A surveiller / migrer si passage Plus.
 *
 * CONFIG : lit window.CordialGiftConfig injecte par snippet Liquid
 * 'cordial-gift-config' (variant IDs + seuils, depuis les theme settings).
 * INERTE si les variant IDs ne sont pas renseignes : ne touche jamais au panier.
 *
 * ANTI-BOUCLE : un verrou (busy) + comparaison "etat cible vs etat courant"
 * empeche tout re-declenchement en boucle. On n'agit que si une correction est
 * reellement necessaire, et on ignore nos propres updates pendant l'operation.
 *
 * Cordial-IA-2026-07-30 - DISJONCTEUR (bug "Trop d'essais" constate par Anthony) :
 * les produits cadeaux etant en BROUILLON jusqu'au go-live, chaque tentative
 * d'auto-ajout echoue en 422 - et comme la reconciliation se rejoue a chaque
 * event panier, un panier >= 59 EUR generait une rafale de requetes vouees a
 * l'echec, jusqu'au rate-limit Shopify (429) qui bloquait TOUTES les operations
 * panier de la session (steppers "Trop d'essais", ajout trio impossible).
 * Correctif : apres MAX_FAILURES echecs consecutifs d'update, la mecanique se
 * coupe pour le reste du chargement de page (retour au vrai "fail silencieux").
 * Un update reussi remet le compteur a zero (comportement go-live intact).
 *
 * Cordial-IA-2026-08-24 - ANTI DOUBLE JIGGER v2 (code promo OSEZCREER, Buy X Get Y) :
 * le code offre le jigger PAYANT au checkout (3 bouteilles 25cl eligibles achetees,
 * le client ajoute le jigger payant, le code le passe a 0 EUR). Sans garde-fou, un
 * tel panier (>= 72 EUR) recevait EN PLUS le jigger cadeau du palier 2 -> 2 jiggers
 * expedies. Correctif : le palier 2 vise une quantite 0 UNIQUEMENT si les 3
 * conditions sont reunies :
 *  a) code promo detecte cote client : cookie Shopify 'discount_code' (pose par le
 *     lien /discount/OSEZCREER, valeur passee par decodeURIComponent, comparaison
 *     insensible a la casse) OU parametre d'URL ?discount=CODE vu sur n'importe
 *     quelle page (memorise en sessionStorage au chargement pour survivre a la
 *     navigation dans l'onglet) ;
 *  b) la variante du jigger PAYANT est presente en ligne NON cadeau du panier ;
 *  c) au moins 3 unites cumulees parmi les variantes de bouteilles 25cl eligibles
 *     au code (sinon le code ne rendra pas le jigger gratuit au checkout : le
 *     client ne doit pas perdre son cadeau palier 2).
 * Un client qui achete le jigger PLEIN TARIF sans code garde donc son cadeau.
 * Config (theme settings) : promoCode / promoJiggerVariantId / promoBottleVariantIds.
 * Un des 3 reglages vide = suppression desactivee, comportement d'avant.
 * Palier 1 (mignonnette) jamais concerne.
 * LIMITE ASSUMEE : si le client tape le code A LA MAIN au checkout sans etre passe
 * par le lien /discount/OSEZCREER (ni ?discount=), le panier ne peut pas le savoir :
 * un panier >= 72 EUR avec le jigger payant peut alors partir avec 2 jiggers. Cas
 * residuel accepte, mitige par l'encart panier ci-dessous (2026-08-25).
 *
 * Cordial-IA-2026-08-25 - ENCART "J'AI UN CODE" + AUTO-AJOUT DU JIGGER PAYANT :
 * le code OSEZCREER est imprime sur un FLYER papier (pas de QR, pas de lien) -
 * le parcours principal est la saisie manuelle. L'encart du tiroir panier
 * (snippets/cordial-promo-code.liquid + assets/cordial-promo-code.js) valide le
 * code cote client et DELEGUE tout a cette mecanique (API window.CordialGiftPromo,
 * en bas de fichier) - reconciliation, anti-boucle et disjoncteur restent UNIQUES :
 *  - detection : le code valide est memorise via le mecanisme v2 ci-dessus
 *    (sessionStorage), l'encart pose aussi le cookie via un fetch /discount/CODE ;
 *  - auto-ajout : code detecte + >= 3 bouteilles eligibles + AUCUN jigger payant
 *    au panier -> ajout de la variante payante via /cart/add.js avec la property
 *    marqueur _cordial_promo_jigger (constante partagee avec cart-drawer.liquid).
 *    Declenche sur FRONT MONTANT des conditions uniquement (sessionStorage
 *    cordialGiftPromoCondMet) : un client qui retire le jigger a la main n'est
 *    jamais contredit, et repasser de 2 a 3 bouteilles le rajoute ;
 *  - retrait symetrique : conditions plus reunies -> seules NOS lignes marquees
 *    sont retirees (par KEY de ligne), jamais un jigger ajoute par le client ;
 *  - sous-total des paliers : la ligne marquee est EXCLUE (comme les cadeaux) du
 *    sous-total qui declenche 59/72 EUR. Elle passera a 0 EUR au paiement : elle
 *    ne doit pas debloquer un palier avec un montant qui ne sera jamais paye.
 *    MEME exclusion dans le Liquid de la barre (snippets/cart-drawer.liquid).
 */
(() => {
  const cfg = window.CordialGiftConfig || {};
  const tiers = [];
  // Construit la liste des paliers valides (variant id numerique + seuil)
  if (cfg.enable) {
    if (cfg.tier1VariantId && cfg.tier1Threshold > 0) {
      tiers.push({ variantId: String(cfg.tier1VariantId), thresholdCents: cfg.tier1Threshold * 100 });
    }
    if (cfg.tier2VariantId && cfg.tier2Threshold > 0) {
      tiers.push({
        variantId: String(cfg.tier2VariantId),
        thresholdCents: cfg.tier2Threshold * 100,
        // Cordial-IA-2026-08-24 - Seul le palier 2 (jigger cadeau) est annulable
        // par le contexte code promo (cf. en-tete). Palier 1 jamais touche.
        promoSuppressible: true,
      });
    }
  }

  // INERTE : aucun palier configure -> on ne s'abonne a rien, panier intact.
  if (!tiers.length) return;

  const giftVariantIds = new Set(tiers.map((t) => t.variantId));

  // Cordial-IA-2026-08-24 - Contexte code promo (anti double jigger v2, cf. en-tete).
  // Les 3 reglages doivent etre renseignes, sinon la suppression est desactivee.
  const promo = {
    code: String(cfg.promoCode || '').trim().toUpperCase(),
    jiggerVariantId: String(cfg.promoJiggerVariantId || '').trim(),
    bottleVariantIds: String(cfg.promoBottleVariantIds || '')
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean),
  };
  const promoActive = Boolean(promo.code && promo.jiggerVariantId && promo.bottleVariantIds.length);
  const promoBottleSet = new Set(promo.bottleVariantIds);
  const PROMO_MIN_BOTTLES = 3; // exigence du code Buy X Get Y : 3 bouteilles 25cl eligibles
  const PROMO_SEEN_KEY = 'cordialGiftPromoCodeSeen';

  // Memorise au chargement le ?discount=CODE vu dans l'URL : sessionStorage
  // survit a la navigation dans l'onglet (se vide a la fermeture de l'onglet).
  if (promoActive) {
    try {
      const param = new URLSearchParams(window.location.search).get('discount');
      if (param && param.trim().toUpperCase() === promo.code) {
        sessionStorage.setItem(PROMO_SEEN_KEY, promo.code);
      }
    } catch (e) { /* silencieux : detection par cookie seulement */ }
  }

  // Lecture cookie brute (document.cookie), '' si absent.
  const readCookie = (name) => {
    const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return match ? match[1] : '';
  };

  // Vrai si le code promo est detecte : cookie Shopify 'discount_code' (pose par
  // le lien /discount/CODE) OU ?discount=CODE deja vu dans la session.
  const promoCodeDetected = () => {
    let raw = '';
    try { raw = readCookie('discount_code'); } catch (e) { /* silencieux */ }
    if (raw) {
      let value = raw;
      try { value = decodeURIComponent(raw); } catch (e) { /* valeur brute */ }
      if (value.trim().toUpperCase() === promo.code) return true;
    }
    try { return sessionStorage.getItem(PROMO_SEEN_KEY) === promo.code; } catch (e) { return false; }
  };

  // Cordial-IA-2026-08-25 - Marqueur de NOS ajouts de jigger payant. Constante
  // partagee (ne pas renommer sans synchroniser) : lue par
  // snippets/cart-drawer.liquid (exclusion du sous-total de la barre + wording).
  // Prefixe '_' = property jamais affichee dans les cartes produits du tiroir.
  const PROMO_JIGGER_PROP = '_cordial_promo_jigger';
  const lineIsPromoJigger = (item) => !!(item.properties && item.properties[PROMO_JIGGER_PROP]);

  // Cordial-IA-2026-08-25 - Front montant de l'auto-ajout (cf. en-tete) : '1'
  // quand "code detecte + 3 bouteilles eligibles" etait DEJA vrai au passage
  // precedent. sessionStorage : survit aux re-rendus du tiroir et a la
  // navigation dans l'onglet. L'encart le remet a zero via markDetected()
  // (validation explicite = l'ajout se rejoue meme apres un retrait manuel).
  const PROMO_COND_KEY = 'cordialGiftPromoCondMet';
  const readCondMet = () => {
    try { return sessionStorage.getItem(PROMO_COND_KEY) === '1'; } catch (e) { return false; }
  };
  const writeCondMet = (met) => {
    try {
      if (met) sessionStorage.setItem(PROMO_COND_KEY, '1');
      else sessionStorage.removeItem(PROMO_COND_KEY);
    } catch (e) { /* silencieux */ }
  };

  let busy = false;       // verrou : une operation cadeau est en cours
  let queued = false;     // une reconciliation a ete demandee pendant le verrou
  let failures = 0;       // disjoncteur : echecs consecutifs d'update (cf. en-tete)
  const MAX_FAILURES = 2;
  // Cordial-IA-2026-07-31 - Le disjoncteur SURVIT aux rechargements (sessionStorage) :
  // dans l'editeur de theme, l'apercu se recharge sans cesse et chaque chargement
  // repartait pour 2 tentatives vouees a l'echec -> la session d'apercu restait
  // rate-limitee en continu ("Trop d'essais" persistant, constate par Anthony).
  // Un succes reel refermera le disjoncteur ; fermer l'onglet le reinitialise.
  const BREAKER_KEY = 'cordialGiftBreakerOpen';
  try { if (sessionStorage.getItem(BREAKER_KEY) === '1') failures = MAX_FAILURES; } catch (e) { /* stockage indisponible : disjoncteur par page */ }

  const ROUTES = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const url = (path) => (ROUTES.replace(/\/$/, '') + path);

  const getCart = async () => {
    const res = await fetch(url('/cart.js'), { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
    if (!res.ok) throw new Error('cart fetch failed');
    return res.json();
  };

  // Sous-total des produits NON cadeaux, en centimes.
  const subtotalExcludingGifts = (cart) => {
    let cents = 0;
    for (const item of cart.items) {
      if (giftVariantIds.has(String(item.variant_id))) continue;
      // Cordial-IA-2026-08-25 - La ligne jigger promo marquee est exclue comme
      // les cadeaux : elle passera a 0 EUR au paiement (code BXGY), ses
      // 10,90 EUR ne doivent pas debloquer un palier 59/72 avec un montant
      // jamais reellement paye. Meme regle dans snippets/cart-drawer.liquid.
      // Un jigger ajoute par le client SANS code (paye plein tarif) reste
      // compte, lui : c'est un vrai achat.
      if (lineIsPromoJigger(item)) continue;
      // line_price = prix de la ligne (qty incluse), en centimes
      cents += item.line_price;
    }
    return cents;
  };

  // Etat courant : pour chaque variant cadeau, quantite presente dans le panier.
  const currentGiftQty = (cart, variantId) => {
    let q = 0;
    for (const item of cart.items) {
      if (String(item.variant_id) === variantId) q += item.quantity;
    }
    return q;
  };

  // Cordial-IA-2026-08-24 - Anti double jigger : vrai si le panier contient une
  // ligne NON cadeau pour ce variant (le jigger PAYANT n'est jamais un cadeau,
  // mais le filtre protege aussi d'une mauvaise config qui pointerait un cadeau).
  const cartHasNonGiftVariant = (cart, variantId) => {
    for (const item of cart.items) {
      if (giftVariantIds.has(String(item.variant_id))) continue;
      if (String(item.variant_id) === variantId) return true;
    }
    return false;
  };

  // Cordial-IA-2026-08-24 - Quantite cumulee des bouteilles 25cl eligibles au code.
  const eligibleBottleQty = (cart) => {
    let q = 0;
    for (const item of cart.items) {
      if (promoBottleSet.has(String(item.variant_id))) q += item.quantity;
    }
    return q;
  };

  // Calcule l'etat cible (qty 1 si seuil franchi, 0 sinon) et renvoie le diff a appliquer.
  const computeUpdates = (cart) => {
    const subtotal = subtotalExcludingGifts(cart);
    // Cordial-IA-2026-08-24 - Anti double jigger v2 : le palier 2 est annule
    // UNIQUEMENT si (a) code promo detecte, (b) jigger payant au panier en ligne
    // non cadeau, (c) au moins PROMO_MIN_BOTTLES bouteilles eligibles au panier.
    // Un acheteur du jigger plein tarif sans code garde donc son cadeau palier 2.
    // (Cordial-IA-2026-08-25 : conditions factorisees, meme logique.)
    const promoDetected = promoActive && promoCodeDetected();
    const promoCondMet = promoDetected && eligibleBottleQty(cart) >= PROMO_MIN_BOTTLES;
    const suppressTier2 = promoCondMet && cartHasNonGiftVariant(cart, promo.jiggerVariantId);
    const updates = {};
    let needsChange = false;
    for (const t of tiers) {
      let targetQty = subtotal >= t.thresholdCents ? 1 : 0;
      if (t.promoSuppressible && suppressTier2) targetQty = 0;
      const have = currentGiftQty(cart, t.variantId);
      if (have !== targetQty) {
        updates[t.variantId] = targetQty;
        needsChange = true;
      }
    }
    // Cordial-IA-2026-08-25 - Retrait symetrique du jigger promo : conditions
    // plus reunies (moins de 3 bouteilles eligibles, ou code plus detecte) ->
    // NOS lignes marquees visent 0, par KEY de ligne et jamais par variant id :
    // une ligne jigger ajoutee par le client (sans marqueur, properties
    // differentes) est une AUTRE ligne et n'est jamais touchee (meme patron que
    // cordial-trio-cart.js ; /cart/update.js accepte les keys). Garde promoActive :
    // config effacee = on ne gere plus les lignes marquees existantes (on ne
    // retire pas une ligne a 10,90 EUR que le client a sous les yeux).
    if (promoActive && !promoCondMet) {
      for (const item of cart.items) {
        if (lineIsPromoJigger(item) && item.quantity > 0) {
          updates[item.key] = 0;
          needsChange = true;
        }
      }
    }
    return { needsChange, updates };
  };

  // Applique les updates via /cart/update.js (idempotent : set qty par variant id).
  const applyUpdates = async (updates) => {
    const res = await fetch(url('/cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates }),
    });
    if (!res.ok) throw new Error('cart update failed');
    return res.json();
  };

  // Rafraichit le tiroir pour que la barre (server-rendered) reflete l'etat cadeaux.
  const refreshDrawer = (cart) => {
    if (!window.eventBus) return;
    try {
      window.eventBus.emit('update:cart:drawer', cart);
    } catch (e) { /* silencieux */ }
  };

  // Cordial-IA-2026-08-25 - Ajout du jigger PAYANT marque, via /cart/add.js
  // (l'ajout d'une ligne AVEC properties n'est pas possible par /cart/update.js).
  const addPromoJigger = async () => {
    const idNum = Number(promo.jiggerVariantId);
    const props = {};
    props[PROMO_JIGGER_PROP] = '1';
    const res = await fetch(url('/cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number.isFinite(idNum) ? idNum : promo.jiggerVariantId, quantity: 1, properties: props }],
      }),
    });
    if (!res.ok) throw new Error('promo jigger add failed');
    return res.json();
  };

  // Cordial-IA-2026-08-25 - Ajout sur FRONT MONTANT uniquement (cf. en-tete) :
  // conditions reunies MAINTENANT mais pas au passage precedent (panier qui
  // atteint 3 bouteilles, ou code tout juste valide dans l'encart - l'encart
  // remet le front a zero via markDetected). Jamais d'ajout si un jigger payant
  // est deja au panier (marque OU ajoute par le client) : le retrait manuel du
  // client est respecte tant que les conditions restent vraies.
  const shouldAddPromoJigger = (cart) => {
    if (!promoActive || !promoCodeDetected()) return false;
    if (eligibleBottleQty(cart) < PROMO_MIN_BOTTLES) return false;
    if (readCondMet()) return false; // conditions deja vraies avant : pas un front montant
    if (cartHasNonGiftVariant(cart, promo.jiggerVariantId)) return false;
    return true;
  };

  // Cordial-IA-2026-08-25 - Etat promo publie vers l'encart "J'ai un code"
  // (assets/cordial-promo-code.js) : calcule a chaque reconciliation, pousse
  // par event document 'cordial:promo:status', memorise pour les re-rendus.
  // C'est aussi ici que le front montant est enregistre (writeCondMet).
  let lastPromoStatus = null;
  const promoStatusFor = (cart) => {
    const bottles = eligibleBottleQty(cart);
    return {
      configured: promoActive,
      detected: promoActive && promoCodeDetected(),
      bottles,
      minBottles: PROMO_MIN_BOTTLES,
      missing: Math.max(0, PROMO_MIN_BOTTLES - bottles),
      jiggerInCart: promoActive && cartHasNonGiftVariant(cart, promo.jiggerVariantId),
    };
  };
  const publishPromoStatus = (cart) => {
    if (!promoActive) return;
    lastPromoStatus = promoStatusFor(cart);
    writeCondMet(lastPromoStatus.detected && lastPromoStatus.missing === 0);
    try {
      document.dispatchEvent(new CustomEvent('cordial:promo:status', { detail: lastPromoStatus }));
    } catch (e) { /* silencieux */ }
  };

  // Reconciliation : recupere le panier, calcule le diff, applique si besoin.
  const reconcile = async () => {
    if (failures >= MAX_FAILURES) return; // disjoncteur ouvert : mecanique coupee jusqu'au prochain chargement
    if (busy) { queued = true; return; }
    busy = true;
    try {
      let cart = await getCart();
      let mutated = false;
      // Cordial-IA-2026-08-25 - L'auto-ajout du jigger promo passe AVANT le
      // calcul des paliers : le panier re-lu apres l'ajout contient la ligne
      // marquee, la suppression du palier 2 (v2) s'applique donc dans la meme
      // passe - jamais d'etat intermediaire avec les 2 jiggers.
      if (shouldAddPromoJigger(cart)) {
        await addPromoJigger();
        cart = await getCart();
        mutated = true;
      }
      const { needsChange, updates } = computeUpdates(cart);
      if (needsChange) {
        cart = await applyUpdates(updates);
        mutated = true;
      }
      if (mutated) {
        failures = 0; // update reussi : le disjoncteur se rearme
        try { sessionStorage.removeItem(BREAKER_KEY); } catch (e2) { /* silencieux */ }
        refreshDrawer(cart);
      }
      // Cordial-IA-2026-08-25 - Statut promo publie a CHAQUE passe (meme sans
      // mutation) : l'encart se met a jour et le front montant est memorise.
      // Pas d'appel en cas d'echec (catch) : le front n'est pas consomme, la
      // tentative se rejouera - plafonnee par le disjoncteur ci-dessous.
      publishPromoStatus(cart);
    } catch (e) {
      // Fail silencieux : on ne casse jamais le panier ni le checkout.
      // Mais on compte l'echec : cadeaux en brouillon = echec garanti a chaque
      // event, le disjoncteur evite la rafale de requetes (rate-limit Shopify).
      failures += 1;
      if (failures >= MAX_FAILURES) {
        try { sessionStorage.setItem(BREAKER_KEY, '1'); } catch (e2) { /* silencieux */ }
      }
      // console.debug('[cordial-gift] reconcile error', e);
    } finally {
      busy = false;
      if (queued) {
        queued = false;
        // Une demande est arrivee pendant l'operation : on rejoue une fois.
        setTimeout(reconcile, 50);
      }
    }
  };

  // Debounce leger pour grouper les rafales d'events.
  let debounceTimer = null;
  const scheduleReconcile = () => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(reconcile, 120);
  };

  // Cordial-IA-2026-08-25 - API publique de l'encart "J'ai un code"
  // (assets/cordial-promo-code.js). L'UI ne touche JAMAIS le panier : elle
  // valide la saisie, marque la detection, puis demande une reconciliation a
  // la mecanique commune (anti-boucle et disjoncteur uniques). markDetected
  // rearme le disjoncteur : une action explicite du client merite une nouvelle
  // chance meme si des tentatives precedentes ont echoue.
  window.CordialGiftPromo = {
    configured: promoActive,
    isDetected: () => promoActive && promoCodeDetected(),
    matches: (raw) => promoActive && String(raw || '').trim().toUpperCase() === promo.code,
    markDetected: () => {
      try {
        sessionStorage.setItem(PROMO_SEEN_KEY, promo.code);
        sessionStorage.removeItem(PROMO_COND_KEY); // front remis a zero : l'ajout se rejoue
        sessionStorage.removeItem(BREAKER_KEY);
      } catch (e) { /* silencieux */ }
      failures = 0;
    },
    lastStatus: () => lastPromoStatus,
    reconcileNow: () => scheduleReconcile(),
  };

  // S'abonne aux events panier du theme (ajout fiche/grille/page selection/tiroir).
  const subscribe = () => {
    if (!window.eventBus) return false;
    window.eventBus.on('cart:added', scheduleReconcile);
    window.eventBus.on('update:cart:drawer', scheduleReconcile);
    window.eventBus.on('render:cart:drawer', scheduleReconcile);
    return true;
  };

  const init = () => {
    // eventBus peut ne pas etre pret immediatement : on retente brievement.
    if (!subscribe()) {
      let tries = 0;
      const iv = setInterval(() => {
        tries += 1;
        if (subscribe() || tries > 20) clearInterval(iv);
      }, 250);
    }
    // Reconciliation au chargement (cas : retour sur le site avec panier existant).
    scheduleReconcile();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
